import { useEffect, useState } from "react";
import { getSession, onTokenUpdate } from "../../../auth";
import {
  tokenSecondsLeft,
  type MMUserSessionType,
} from "../../../auth/messagemedia";

export const useMmToken = (refresh = true): string | undefined => {
  const [session, setSession] = useState<{
    accessToken?: string;
    refreshToken?: string;
    expireIn?: number;
    createdAt?: number;
  }>();

  useEffect(() => {
    let refreshTimeout: NodeJS.Timeout;
    if (!session) {
      getSession().then(setSession);
    } else if (refresh) {
      const refreshTimeInSeconds =
        session.createdAt && session.expireIn
          ? tokenSecondsLeft(session as MMUserSessionType) - 2
          : 120;

      refreshTimeout = setTimeout(() => {
        getSession().then(setSession);
      }, refreshTimeInSeconds * 1000);
    }
    return () => refreshTimeout && window.clearTimeout(refreshTimeout);
  }, [refresh, session]);

  useEffect(() => {
    const unsubscribe = onTokenUpdate(() => getSession().then(setSession));

    return unsubscribe;
  }, []);

  return session?.accessToken;
};
